import * as React from "react";
import { getMediaQueries } from "baseui/helpers/responsive-helpers";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import {
  DisplayLarge as BaseDisplayLarge,
  DisplayMedium as BaseDisplayMedium,
  DisplaySmall as BaseDisplaySmall,
  DisplayXSmall as BaseDisplayXSmall,
  HeadingLarge as BaseHeadingLarge,
  HeadingMedium as BaseHeadingMedium,
  HeadingSmall as BaseHeadingSmall,
  HeadingXSmall as BaseHeadingXSmall,
  LabelLarge as BaseLabelLarge,
  LabelMedium as BaseLabelMedium,
  LabelSmall as BaseLabelSmall,
  LabelXSmall as BaseLabelXSmall,
  ParagraphLarge as BaseParagraphLarge,
  ParagraphMedium as BaseParagraphMedium,
  ParagraphSmall as BaseParagraphSmall,
  ParagraphXSmall as BaseParagraphXSmall,
} from "baseui/typography";

/* eslint-disable react/prop-types */
// TODO: Enable the proptype check next time when this file is changed

export function DisplayLarge(props) {
  return <Typography component={BaseDisplayLarge} {...props} />;
}

export function DisplaySubLarge(props) {
  return <Typography component={BaseDisplayLarge} {...props} />;
}

export function DisplayMedium(props) {
  return <Typography component={BaseDisplayMedium} {...props} />;
}

export function DisplaySmall(props) {
  return <Typography component={BaseDisplaySmall} {...props} />;
}

export function DisplaySemiSmall(props) {
  return <Typography component={BaseDisplaySmall} {...props} />;
}

export function DisplayXSmall(props) {
  return <Typography component={BaseDisplayXSmall} {...props} />;
}

export function DisplayTiny(props) {
  return <Typography component={BaseDisplayXSmall} font="DisplayTiny" {...props} />;
}

export function HeadingLarge(props) {
  return <Typography component={BaseHeadingLarge} font="HeadingLarge" {...props} />;
}

export function HeadingMedium(props) {
  return <Typography component={BaseHeadingMedium} font="HeadingMedium" {...props} />;
}

export function HeadingSmall(props) {
  return <Typography component={BaseHeadingSmall} font="HeadingSmall" {...props} />;
}

export function HeadingXSmall(props) {
  return <Typography component={BaseHeadingXSmall} font="HeadingXSmall" {...props} />;
}

export function LabelLarge(props) {
  return <Typography component={BaseLabelLarge} font="LabelLarge" {...props} />;
}

export function LabelMedium(props) {
  return <Typography component={BaseLabelMedium} font="LabelMedium" {...props} />;
}

export function LabelSmall(props) {
  return <Typography component={BaseLabelSmall} font="LabelSmall" {...props} />;
}

export function LabelXSmall(props) {
  return <Typography component={BaseLabelXSmall} font="LabelXSmall" {...props} />;
}

export function ParagraphLarge(props) {
  return <Typography component={BaseParagraphLarge} {...props} />;
}

export function ParagraphMedium(props) {
  return <Typography component={BaseParagraphMedium} {...props} />;
}

export function ParagraphSmall(props) {
  return <Typography component={BaseParagraphSmall} {...props} />;
}

export function ParagraphXSmall(props) {
  return <Typography component={BaseParagraphXSmall} {...props} />;
}

function Typography(props) {
  const [, theme] = useStyletron();
  const {
    component: Component,
    center,
    $style,
    color = theme.colors.contentPrimary,
    ...restProps
  } = props;
  return (
    <Component
      color={color}
      $style={{
        ...getCenter(center, theme),
        ...($style || {}),
      }}
      {...restProps}
    />
  );
}

function getCenter(center, theme) {
  if (Array.isArray(center)) {
    const styles = build(theme.breakpoints);
    styles.apply({
      property: "textAlign",
      value: center,
      transform: (c) => (c ? "center" : "inherit"),
    });
    return styles.value();
  }
  return {
    textAlign: center ? "center" : "inherit",
  };
}

// TODO: This was lifted from BaseWeb. We could probably refactor and
// reuse elsewhere?
function build(breakpoints) {
  const styles = {};
  const mediaQueries = getMediaQueries(breakpoints);

  return {
    apply: ({ property, transform = (x) => x, value }) => {
      if (value === null || value === undefined) {
        return;
      }

      if (Array.isArray(value)) {
        value.forEach((v, index) => {
          // Do not create a media query for the smallest breakpoint.
          if (index === 0) {
            styles[property] = constrainToNull(transform(v));
            return;
          }

          const mediaQuery = mediaQueries[index - 1];
          if (!styles[mediaQuery]) {
            styles[mediaQuery] = {};
          }

          styles[mediaQuery][property] = constrainToNull(transform(v));
        });
      } else {
        styles[property] = constrainToNull(transform(value));
      }
    },
    value: () => styles,
  };
}

function constrainToNull(value) {
  if (value === undefined) {
    return null;
  }
  return value;
}
